'use client'

import type { HTMLProps } from 'react'
import clsx from 'classnames'
import { useLocale } from 'use-intl'
import { Text } from '@/shared/ui'
import { IEventCategory } from '@/interfaces/events'
import { formatter, getDateLabel } from '@/shared/utils'
import { TagEvent } from '@/shared/ui/tag-event'
import style from './event-header.module.scss'

type EventHeaderProps = HTMLProps<HTMLDivElement> & {
  date: string
  category: IEventCategory
  light?: boolean
  location: string
}

export const EventHeader = ({ className, category, date, location, light = false }: EventHeaderProps) => {
  const currentLocale = useLocale()

  return (
    <header className={clsx(style.header, className, { [style.light]: light })}>
      <TagEvent className={style.label} color={category?.color}>
        {category?.name}
      </TagEvent>
      {date && (
        <Text className={clsx(style.label, style.date)} type="d" tagName="span">
          {getDateLabel({ date, locale: currentLocale })}
        </Text>
      )}
      {location && (
        <Text className={clsx(style.label, style.location)} type="d" tagName="span">
          {location}
        </Text>
      )}
    </header>
  )
}
